'use client'

import { cn } from 'oddle-shop-monorepo.design-system'
import { ReactNode } from 'react'
import CustomText from './CustomText'
import Newsletter from './Newsletter'
import SocialMedia from './SocialMedia'
import { FetchBaseQueryError } from '@reduxjs/toolkit/query'
import { SerializedError } from '@reduxjs/toolkit'

interface CustomisationContentProps {
  blocksData: {
    id: string
    type: string
    settings: {
      bodyText: string
      headingsText: string
      requestSubscriberName: boolean
      successMessageText: string
      facebookUrl: string
      instagramUrl: string
      twitterUrl: string
      youtubeUrl: string
    }
  }[]
  previewMode: boolean
  newsletterSignupAction: ({
    email,
    firstName,
    lastName,
  }: {
    email: string
    firstName: string
    lastName: string
  }) => Promise<
    | {
        data: Local.V4ApiResponse<string, unknown>
        error?: undefined
      }
    | {
        data?: undefined
        error: FetchBaseQueryError | SerializedError
      }
  >
}

const CustomisationContent = ({
  blocksData,
  previewMode,
  newsletterSignupAction,
}: CustomisationContentProps): ReactNode => {
  const numberOfBlock = blocksData?.length || 0
  if (numberOfBlock === 0) return null

  const renderBlock = (
    blockData: CustomisationContentProps['blocksData'][0]
  ) => {
    switch (blockData.type) {
      case 'custom-text':
        return <CustomText settings={blockData.settings} />
      case 'newsletter':
        return (
          <Newsletter
            settings={blockData.settings}
            previewMode={previewMode}
            newsletterSignupAction={newsletterSignupAction}
          />
        )
      case 'social-media':
        return <SocialMedia settings={blockData.settings} />
      default:
        return null
    }
  }

  return (
    <div className="border-lines-and-borders border-b pb-8">
      <div
        className={cn(
          'grid gap-8',
          numberOfBlock === 2 && 'grid-cols-2',
          numberOfBlock === 3 && 'grid-cols-3',
          numberOfBlock === 4 && 'grid-cols-4',
          numberOfBlock === 5 && 'grid-cols-5',
          'grid-cols-1 md:grid-cols-[repeat(auto-fit,_minmax(0,_1fr))]'
        )}
      >
        {blocksData.map((blockData) => {
          const blockElement = renderBlock(blockData)
          if (!blockElement) return null

          return (
            <div key={blockData.id} className="mt-8">
              {blockElement}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default CustomisationContent
